
/* used to set sync action for try again call */

export default function setSyncAction (action) {
    this.syncAction = action;
}